import { apiv2_fetchUserPreferences, apiv2_fetchUserProfile } from "@/app/api2"
import { mainLogger as log } from "@/app/logger"
import { LocalStorage } from "@/app/storage"
import { defaultInitialState } from "@/app/stores/user/initial_state"
import { UserStore } from "@/app/stores/user/types"
import { createStore } from "zustand/vanilla"

export const createUserStore = () => {
  return createStore<UserStore>()((set, get) => ({
    ...defaultInitialState,

    setUser: (user) => set({ user, isLoggedIn: true }),

    updateUser: (user) => {
      set((state) => ({
        user: state.user ? { ...state.user, ...user } : null,
      }))
    },

    updatePreferences: (preferences) => set({ preferences }),

    fetchAndUpdateUserData: async (auth0User) => {
      try {
        const { setUser, updatePreferences, preferences } = get()

        const [userProfile, userPreferences] = await Promise.all([
          apiv2_fetchUserProfile(),
          apiv2_fetchUserPreferences(),
        ])

        if (userProfile && userPreferences) {
          setUser({
            id: auth0User.sub ?? "",
            name: userProfile?.firstName ?? "",
            picture: auth0User.picture ?? "",
            email: userProfile?.email ?? auth0User.email,
            firstName: userProfile?.firstName ?? "",
            lastName: userProfile?.lastName ?? "",
            company: userProfile?.company ?? "",
            jobFunction: userProfile?.jobFunction ?? null,
            jobRole: userProfile?.jobRole ?? null,
            otherJobRole: userProfile?.otherJobRole ?? "",
            userKey: userProfile.userKey,
            isAdmin: userProfile.isAdmin,
          })

          const isUserPreferencesEmpty =
            Object.keys(userPreferences).length === 0

          updatePreferences(
            isUserPreferencesEmpty ? preferences : userPreferences
          )

          if (isUserPreferencesEmpty)
            LocalStorage.set("userPreferences", preferences)
        }
      } catch (error) {
        log.error("[USER STORE] Error fetching user data:", error)
        return null
      }
    },
  }))
}
